/*
 * sleeve-cart.js -- removes a whole sleeve build (sleeve + its patch lines)
 * from the cart in one go. Markup: snippets/sleeve-cart-row.liquid.
 */
if (!customElements.get('sleeve-remove-button')) {
  customElements.define(
    'sleeve-remove-button',
    class SleeveRemoveButton extends HTMLElement {
      connectedCallback() {
        this.querySelector('button').addEventListener('click', () => this.removeBuild());
      }

      removeBuild() {
        const keys = (this.dataset.keys || '').split(',').filter(Boolean);
        if (!keys.length) return;
        const updates = {};
        keys.forEach((k) => (updates[k] = 0));
        const drawer = this.closest('cart-drawer');
        const row = this.closest('tr');
        if (row) row.style.opacity = '0.4';

        fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((state) => {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sleeve-remove', cartData: state });
            }
            if (drawer && state.sections && typeof drawer.renderContents === 'function') {
              drawer.renderContents(state);
              if (!state.item_count) drawer.classList.add('is-empty');
            } else {
              window.location.reload();
            }
          })
          .catch(() => window.location.reload());
      }
    }
  );
}
